let elementsForm,contLogin = 1;

function validationForm(elementsForm,contLogin)
{
  for(let i=0;i<elementsForm.length;i++){
    if ( $.trim($("#"+elementsForm[i]).val()) == "" ) {
      contLogin = 0;
    }
  }
  return contLogin;
}
/*
function validarEmail(valor) {
  if (/^\w+([\.-]?\w+)*@(?:|hotmail|outlook|yahoo|live|gmail|gutand|yopmail)\.(?:|com|es)+$/.test(valor)){
    return true;
  } else {
    return false;
  }
}
*/
$('.btnFormContact').click(function () {
  grecaptcha.ready(function() {
    grecaptcha.execute('6LfRdtwZAAAAAGAsZTr769WArVkDxPg3hV2MFeU7', {action: 'submit'}).then(function(token) {
      $('#formContact').prepend('<input type="hidden" name="token" value="' + token + '">');
      $('#formContact').submit();
  });
});
//  $('#formContact').submit();
});

$('#formContact').on('submit',function (e) {
  e.preventDefault();
  elementsForm = [
    "nameContact",
    "name2Contact",
    "phoneContact",
    "mailContact",
    "checkin",
    "checkout",
    "rooms",
    "ambient",
    "adult",
    "children",
  ];


  contLogin = validationForm(elementsForm,contLogin = 1);
  if(contLogin == 0)
  {
    swal({
      text: "Debes digitar todos los datos requeridos",
      icon: imageURL,
      button: "OK",
    });
    return false;
  }
  /*
  if(!validarEmail($('#mailContact').val())){
    swal({
      text: "Debes digitar un correo valido",
      icon: imageURL,
      button: "OK!",
    });
    $('#mailContact').addClass('error');
    return false;
  }
  */
  let data = $(this).serialize();
  swal({
    text: "Espere un momento",
    icon: imageURL,
    button: false,
    closeOnClickOutside: false,
  });
  $.ajax({
    url: https + "/booking",
    method: "POST",
    data: data,
    success: function (data) {
      if ($.trim(data) == "1") {
        $("#formContact")[0].reset();
        swal({
          text: "Su pre-reserva ha sido registrada",
          icon: imageURL,
          timer: 3000,
          button: "OK",
        });
      }else {
        swal({
          text: "Error, hubo problemas",
          icon: imageURL,
          timer: 3000,
          button: "OK!",
        });
      }
    }
  });
});
